import { assign, concat, remove } from "lodash";
import {
  FETCH_REASON_FOR_LEAVING_FAILURE,
  FETCH_REASON_FOR_LEAVING_REQUEST,
  FETCH_REASON_FOR_LEAVING_SUCCESS,
  ADD_REASON_FOR_LEAVING_REQUEST,
  DELETE_REASON_FOR_LEAVING_REQUEST
} from "../types";

const reason_for_leaving = (state, { type, payload }) => {
  switch (type) {
    case FETCH_REASON_FOR_LEAVING_REQUEST:
      return {
        ...state,
        reason_for_leaving: {
          ids: {},
          loading: false
        }
      };
    case FETCH_REASON_FOR_LEAVING_SUCCESS:
      return {
        ...state,
        reason_for_leaving: assign({}, state.reason_for_leaving, {
          ids: payload.items,
          loading: false
        })
      };
    case ADD_REASON_FOR_LEAVING_REQUEST:
      return {
        ...state,
        reason_for_leaving: assign({}, state.reason_for_leaving, {
          ids: concat(payload.items, state.reason_for_leaving.ids)
        })
      };
    case DELETE_REASON_FOR_LEAVING_REQUEST:
      const ids = remove(
        [...state.reason_for_leaving.ids],
        object => object !== payload.id
      );
      return {
        ...state,
        reason_for_leaving: assign({}, state.reason_for_leaving, {
          ids
        })
      };
    case FETCH_REASON_FOR_LEAVING_FAILURE:
      return {
        ...state,
        reason_for_leaving: {
          ids: {},
          loading: false
        }
      };
    default:
      return {
        ...state
      };
  }
};

export default reason_for_leaving;
